import Swiper from "./swiper-bundle.esm.browser.min.js";
import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe-lightbox.esm.min.js';

class SliderLG extends HTMLElement {
    constructor() {
      super();
     
    }
  
    connectedCallback() {
     this.swiperContainer = this.querySelector(".slider-lg__swiper");
     this.swiperWrapper = this.querySelector(".slider-lg__swiper-wrapper");
     this.mobileGap = parseInt(this.dataset.mobileGap);
     this.desktopGap = parseInt(this.dataset.desktopGap);

     this.swiper = new Swiper(this.swiperContainer, {
        enableOnMedia : "(min-width: 0px)",
        zoom: true,
        wrapperClass: "slider-lg__swiper-wrapper",
        navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
        },
        pagination: {
            el: ".slider-lg__pagination",
            clickable: true,
        },
        slidesPerView: 'auto',
        spaceBetween: this.mobileGap,
        centeredSlides: true,
        loop: true,
        slideClass: "slider-lg__slide",
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            900: {
                spaceBetween: this.desktopGap,
            }
        },
        on: {
            init: () => {
                const lightbox = new PhotoSwipeLightbox({
                    // ważne: ignoruj klony slajdów gdy używasz loop:true
                    gallery: '.slider-lg__swiper-wrapper',
                    children: '.slider-lg__slide:not(.swiper-slide-duplicate)',
                    pswpModule: () => import('https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe.esm.min.js'),
                    paddingFn: () => ({ top: 20, bottom: 20, left: 20, right: 20 }),
                    closeOnVerticalDrag: true,
                    wheelToZoom: true,
                    bgOpacity: 1
                  });
                
                  lightbox.init();
            }
            // init: () => {
            // const lg = lightGallery(this.swiperWrapper, {
            //     speed: 300
            // });
            //   this.swiperWrapper.addEventListener("lgBeforeClose", () => {
            //     this.swiper.slideTo(lg.index, 0);
            //   });
            // }
        }
     });
    }
  
    disconnectedCallback() {
    
    }
  }
  customElements.define("slider-lg", SliderLG);